import { flatMap } from 'lodash';

export function intersperse<T>(array: T[], element: T): T[] {
  return flatMap(array, (item, index) =>
    index < array.length - 1 ? [item, element] : [item]
  );
}
